import { render, staticRenderFns } from "./freeze-amount-list.vue?vue&type=template&id=1b4cee52&scoped=true&"
import script from "./freeze-amount-list.vue?vue&type=script&lang=js&"
export * from "./freeze-amount-list.vue?vue&type=script&lang=js&"
import style0 from "./freeze-amount-list.vue?vue&type=style&index=0&id=1b4cee52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cee52",
  null
  
)

export default component.exports